import { CommonModule } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ArchwizardModule } from 'angular-archwizard';

import { registerLocaleData } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { MxAlertService, MxBaseRestModule, MxCommonsModule } from 'mx-commons';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ModalModule } from 'ngx-bootstrap/modal';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { DateFnsModule } from 'ngx-date-fns';
import { NgxSmartModalModule } from 'ngx-smart-modal';
import { ToastrModule } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpConfigInterceptor } from './http.interceptor';
import { LoginModule } from './layout/login/login.module';
import {DataTableListModule} from '../lib/data-table-list/data-table-list.module';
import { AuthGuard } from './shared';
import { SharedComponentModule } from './shared/components/shared-component.module';
import { LanguageTranslationModule } from './shared/modules/language-translation/language-translation.module';
import { SharedPipesModule } from './shared/pipes/shared-pipes.module';

import localePt from '@angular/common/locales/pt';
import { BnNgIdleService } from 'bn-ng-idle';
import { ConfigurationService } from './layout/configuration/configuration.service';
import { UploadService } from './shared/components/upload/upload.service';
registerLocaleData(localePt);

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    CommonModule,
    DataTableListModule,
    HttpClientModule,
    LanguageTranslationModule,
    BsDatepickerModule.forRoot(),
    ModalModule.forRoot(),
    PaginationModule.forRoot(),
    ToastrModule.forRoot(),
    ArchwizardModule,
    AppRoutingModule,
    MxCommonsModule,
    MxBaseRestModule.forRoot({
      baseBackEnd: environment.baseUrl,
      baseApi: environment.baseApi,
    }),
    TabsModule.forRoot(),
    NgSelectModule,
    SharedPipesModule,
    SharedComponentModule,
    NgxSmartModalModule.forRoot(),
    LoginModule,
    DateFnsModule.forRoot(),
  ],
  declarations: [AppComponent],
  providers: [
    BnNgIdleService,
    MxAlertService,
    AuthGuard,
    UploadService,
    ConfigurationService,
    { provide: LOCALE_ID, useValue: 'pt' },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpConfigInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
  exports: [],
  entryComponents: [],
})
export class AppModule {}
